// extracted by mini-css-extract-plugin
export default {"box":"filterPage_box__B7miJ","box__content":"filterPage_box__content__XGZL-","box__btn":"filterPage_box__btn__hvmj8"};